export const nameOfAccountData = {
  title: "What's the name of the account?",
  placeHolder: 'e.g. Gold account',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/070f0f1056f0-tooliconmyaccount.jpg',
  },
}
